module.exports = __webpack_public_path__ + "img/1532746777.4dfad7fc.jpg";